import { Injectable } from '@angular/core';
import { ScannableToScanConfig } from '@ng-cloud/badger-core/models/scannable-to-scan-config';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';

@Injectable()
export class ScannableToScanConfigService extends ApiService {

  /**
   * Fetch all ScanConfigTypes
   */
  listScannableToScanConfigs(organizationId: number, params?: any): Observable<ScannableToScanConfig[]> {
    let url = `organizations/${organizationId}/scannable_to_scan_configs`;
    return this.list(ScannableToScanConfig, url, params);
  }
}
